export default __webpack_public_path__ + "static/greg-a38d81cb550cdc17a0c8c842e88f7287.jpg";